/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Engagement_Week_To_GoInputs */

const en_us2_engagement_week_to_go = /** @type {(inputs: Engagement_Week_To_GoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 workout to close the week`);
	return /** @type {LocalizedString} */ (`${i?.count} workouts to close the week`)
	
};

const pt_br2_engagement_week_to_go = /** @type {(inputs: Engagement_Week_To_GoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 treino para fechar a semana`);
	return /** @type {LocalizedString} */ (`Faltam ${i?.count} treinos para fechar a semana`)
	
};

const es_419_engagement_week_to_go = /** @type {(inputs: Engagement_Week_To_GoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 entrenamiento para cerrar la semana`);
	return /** @type {LocalizedString} */ (`Faltan ${i?.count} entrenamientos para cerrar la semana`)
	
};

const pt_pt2_engagement_week_to_go = /** @type {(inputs: Engagement_Week_To_GoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 treino para fechar a semana`);
	return /** @type {LocalizedString} */ (`Faltam ${i?.count} treinos para fechar a semana`)
	
};

const fr_fr2_engagement_week_to_go = /** @type {(inputs: Engagement_Week_To_GoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Plus qu'1 séance pour boucler la semaine`);
	return /** @type {LocalizedString} */ (`Plus que ${i?.count} séances pour boucler la semaine`)
	
};

const de_de2_engagement_week_to_go = /** @type {(inputs: Engagement_Week_To_GoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Noch 1 Training bis zum Wochenziel`);
	return /** @type {LocalizedString} */ (`Noch ${i?.count} Trainings bis zum Wochenziel`)
	
};

const it_it2_engagement_week_to_go = /** @type {(inputs: Engagement_Week_To_GoInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Manca 1 allenamento per chiudere la settimana`);
	return /** @type {LocalizedString} */ (`Mancano ${i?.count} allenamenti per chiudere la settimana`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 workout to close the week" |
* | * | "{count} workouts to close the week" |
*
* @param {Engagement_Week_To_GoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_week_to_go = /** @type {((inputs: Engagement_Week_To_GoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Week_To_GoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_week_to_go(inputs)
	if (locale === "es-419") return es_419_engagement_week_to_go(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_week_to_go(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_week_to_go(inputs)
	if (locale === "de-DE") return de_de2_engagement_week_to_go(inputs)
	if (locale === "it-IT") return it_it2_engagement_week_to_go(inputs)
	return en_us2_engagement_week_to_go(inputs)
});
export { engagement_week_to_go as "engagement.week_to_go" }